// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qr-confirmation-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 50%, #f0f9ff 100%);
  padding: 2rem;
}

.qr-confirmation-container {
  background: white;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.1);
  padding: 40px;
  text-align: center;
  max-width: 500px;
  width: 100%;
}

.qr-logo {
  width: 60px;
  height: 60px;
  object-fit: contain;
  margin-bottom: 10px;
}

.success-icon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #22c55e;
  color: #fff;
  font-size: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
}

.qr-confirmation-container h1 {
  font-size: 1.75rem;
  color: #111827;
  margin-bottom: 0.5rem;
}

.visitor-greeting {
  font-size: 1.1rem;
  color: #374151;
  margin-bottom: 0.25rem;
}

.visit-type-label {
  color: #6b7280;
  font-size: 0.9rem;
  margin-bottom: 2rem;
}

.qr-code-wrapper {
  margin: 1.5rem auto;
  padding: 1rem;
  background: #fff;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  display: inline-block;
}

.expiry-countdown {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  margin: 1.5rem 0;
}

.countdown-label {
  font-size: 0.85rem;
  color: #6b7280;
}

.countdown-timer {
  font-size: 1.5rem;
  font-weight: 700;
  color: #ef4444;
  font-family: 'Courier New', monospace;
}

.qr-instructions {
  margin: 1.5rem 0;
  color: #374151;
  font-size: 0.95rem;
  line-height: 1.6;
}

.email-notice {
  color: #6b7280;
  font-size: 0.85rem;
  margin-top: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/QRConfirmation.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0EAA0E;EAC1E,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;EACvC,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":[".qr-confirmation-page {\r\n  min-height: 100vh;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 50%, #f0f9ff 100%);\r\n  padding: 2rem;\r\n}\r\n\r\n.qr-confirmation-container {\r\n  background: white;\r\n  border-radius: 20px;\r\n  box-shadow: 0 10px 40px rgba(0,0,0,0.1);\r\n  padding: 40px;\r\n  text-align: center;\r\n  max-width: 500px;\r\n  width: 100%;\r\n}\r\n\r\n.qr-logo {\r\n  width: 60px;\r\n  height: 60px;\r\n  object-fit: contain;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.success-icon {\r\n  width: 72px;\r\n  height: 72px;\r\n  border-radius: 50%;\r\n  background: #22c55e;\r\n  color: #fff;\r\n  font-size: 2.5rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 0 auto 1.5rem;\r\n}\r\n\r\n.qr-confirmation-container h1 {\r\n  font-size: 1.75rem;\r\n  color: #111827;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.visitor-greeting {\r\n  font-size: 1.1rem;\r\n  color: #374151;\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.visit-type-label {\r\n  color: #6b7280;\r\n  font-size: 0.9rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.qr-code-wrapper {\r\n  margin: 1.5rem auto;\r\n  padding: 1rem;\r\n  background: #fff;\r\n  border: 2px solid #e5e7eb;\r\n  border-radius: 12px;\r\n  display: inline-block;\r\n}\r\n\r\n.expiry-countdown {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.25rem;\r\n  margin: 1.5rem 0;\r\n}\r\n\r\n.countdown-label {\r\n  font-size: 0.85rem;\r\n  color: #6b7280;\r\n}\r\n\r\n.countdown-timer {\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  color: #ef4444;\r\n  font-family: 'Courier New', monospace;\r\n}\r\n\r\n.qr-instructions {\r\n  margin: 1.5rem 0;\r\n  color: #374151;\r\n  font-size: 0.95rem;\r\n  line-height: 1.6;\r\n}\r\n\r\n.email-notice {\r\n  color: #6b7280;\r\n  font-size: 0.85rem;\r\n  margin-top: 0.5rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
